export default {
  mounted() {
    this.resize()
    this.el.addEventListener("input", () => this.resize())
  },
  updated() {
    this.resize()
  },
  resize() {
    const maxLines = parseInt(this.el.dataset.maxLines || "3")
    const lineHeight = parseInt(getComputedStyle(this.el).lineHeight) || 20
    const paddingTop = parseInt(getComputedStyle(this.el).paddingTop) || 0
    const paddingBottom = parseInt(getComputedStyle(this.el).paddingBottom) || 0
    const maxHeight = maxLines * lineHeight + paddingTop + paddingBottom

    this.el.style.height = "auto"
    const newHeight = Math.min(this.el.scrollHeight, maxHeight)
    this.el.style.height = newHeight + "px"
    this.el.style.overflowY = this.el.scrollHeight > maxHeight ? "auto" : "hidden"
  }
}
